import { z } from "zod";

const mapboxErrorTypeValues = ["REQUEST_FAILED", "REQUEST_UNREACHABLE", "INVALID_RESPONSE"] as const;

const mapboxErrorTypeSchema = z.enum(mapboxErrorTypeValues);
const MapboxErrorType = mapboxErrorTypeSchema.enum;
type MapboxErrorType = z.infer<typeof mapboxErrorTypeSchema>;

interface ErrorDetails {
  sentryDescription: string;
}

export type MapboxErrors =
  | {
      errorType: typeof MapboxErrorType.REQUEST_FAILED;
      data: { status: number; originCount: number };
    }
  | {
      errorType: typeof MapboxErrorType.REQUEST_UNREACHABLE;
      data: { originCount: number; isTimeout: boolean };
    }
  | {
      errorType: typeof MapboxErrorType.INVALID_RESPONSE;
      data: { originCount: number; reason: string };
    };

export const mapboxErrorDetails: Record<MapboxErrorType, ErrorDetails> = {
  [MapboxErrorType.REQUEST_FAILED]: {
    sentryDescription:
      "The Mapbox Matrix API returned a non-success status. A 401 or 403 usually means the token's URL restrictions reject the Referer.",
  },
  [MapboxErrorType.REQUEST_UNREACHABLE]: {
    sentryDescription: "The Mapbox Matrix API did not respond before the timeout or the connection failed",
  },
  [MapboxErrorType.INVALID_RESPONSE]: {
    sentryDescription: "The Mapbox Matrix API returned a body that does not match the expected durations shape",
  },
};
